module.exports = __webpack_public_path__ + "static/media/Mr Edmond Yu.c7c000a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Mr Edmond Yu.jpg
// module id = 179
// module chunks = 0